import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/portfolio/portfolio.daily.query.gql"
import type {
  PortfolioDailyQuery,
  PortfolioDailyQueryVariables,
} from "@/v2-backoffice-client/portfolio/__types__/portfolio.daily.query"

type Options = QueryHookOptions<
  PortfolioDailyQuery,
  PortfolioDailyQueryVariables
>

export function usePortfolioDailyQuery(options?: Options) {
  return useQuery<PortfolioDailyQuery, PortfolioDailyQueryVariables>(
    query,
    options,
  )
}
